import { speciesMenuSkeleton } from "../data/speciesMenuSkeleton";

// A taxidermy registrant is tagged in the CRM with only the taxidermy
// interest. There is no explicit member-type flag anywhere in the API, so
// "taxidermy is the sole interest" is the rule; keep it key-agnostic so
// interest-key drift cannot widen a member's view by accident.
export const isTaxidermyOnly = (interests) => {
  if (!interests || !interests.taxidermy) {
    return false;
  }
  return Object.keys(interests).every(
    (key) => key === "taxidermy" || !interests[key]
  );
};

// Route paths a taxidermy-only member is steered away from. Used directly as
// a react-router <Route path> so the check re-runs on every navigation.
export const TAXIDERMY_BLOCKED_PATHS = speciesMenuSkeleton
  .filter((entry) => entry.apiName !== "taxidermy")
  .map((entry) => `/${entry.apiName}`)
  .concat(["/inventory-list", "/search"]);

export const blockedForTaxidermyOnly = (pathname) =>
  TAXIDERMY_BLOCKED_PATHS.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
